import script from "./ReportFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportFormView.vue?vue&type=script&setup=true&lang=js"

import "./ReportFormView.vue?vue&type=style&index=0&id=15734106&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15734106"]])

export default __exports__